module.exports = __webpack_public_path__ + "SourceSansPro-Italic.64db72197418eb4faa80.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/SourceSansPro-Italic.woff
// module id = ../../../../../src/assets/customfonts/SourceSansPro-Italic.woff
// module chunks = styles